{
  "noQuestions": "Питання відсутні",
  "form": {
    "instruction": {
      "title": "Інструкція"
    }
  },
  "errorScreen": {
    "errorHeading": "Упс, сталася помилка :(",
    "supportNotification": "Команду підтримки повідомлено. Напишіть нам якщо проблема не вирішується тривалий час.",
    "buttonLinkText": "На Головний Екран"
  },
  "formItemWrapper": {
    "confirmButton": "Підтвердити",
    "backButton": "Назад",
    "infoText": "Можна обрати декілька варіантів",
    "keyboardInstruction": "Вибирайте відповідь, натиснувши цифру на клавіатурі"
  },
  "QuestionnaireHeader": {
    "instruction": "Інструкція",
    "button": "Ок"
  },

  "QuestionnaireMarkDownContent": {
    "instruction": "Або натисніть клавішу Ентер",
    "button": "Далі"
  },
  "SuccessScreen": {
    "title": "Ваші відповіді успішно збережено!",
    "text": "Після завершення діагностики на головному екрані з’являться ваші персональні результати та рекомендації, які допоможуть визначити подальші кроки — це може бути психоедукація, самостійна робота або консультація з фахівцем.",
    "greetingMessage": "Дякуємо, що приділили час цьому важливому кроку до кращого розуміння себе!",
    "linkText": "На Головний Екран"
  }
}
